<template>
    <div>
        <div class="dx-field ai-form-text-box-readonly">
            <div class="dx-field-label ai-form-text-box-readonly-label">{{ meta.title }}</div>
            <div :class="fieldValueClass">
                <dx-text-box :value="serverData[meta.fieldNameText]" :read-only="true" />
            </div>
        </div>
    </div>
</template>
<script setup>
import { DxTextBox } from 'devextreme-vue';
import { computed } from 'vue';

const props = defineProps({
    meta: {
        type: Object,
        default: () => {},
    },
    serverData: {
        type: Object,
        default: () => {},
    },
    isModified: {
        type: Boolean,
        default: () => false,
    }
});

const fieldValueClass = computed(() => {
    return {
        'dx-field-value': true,
        'ai-field-modified': props.isModified,
    };
});
</script>
<style lang="scss" scoped>
.ai-form-text-box-readonly {
}
.ai-form-text-box-readonly-label {
}
</style>
